import { importLibrary, setOptions } from '@googlemaps/js-api-loader'

const encryptedKey = window?.drupalSettings?.google?.map?.GOOGLE_MAP_KEY ?? 'AIzaSyBITbXxRXxkGmFHxATW7Qj3bRXIs6oo0no'

const useKey = window?.drupalSettings?.google?.map?.use_key ?? true

const client = window?.drupalSettings?.google?.map?.GOOGLE_MAP_CLIENT ?? ''

const channel = window?.drupalSettings?.google?.map?.GOOGLE_MAP_CHANNEL ?? ''

const mapIDs = window.drupalSettings?.google?.map?.MAP_IDS || {};

const getPinSVG = function () {
  const parser = new DOMParser();
  const pin = parser.parseFromString(`
    <svg width="29" height="40" viewBox="0 0 21 30" xmlns="http://www.w3.org/2000/svg" class="map-custom-pin">
      <path d="M10.4184 29.2971L10.2548 29.1416C10.1511 29.0461 0 19.3777 0 10.4184C0 4.67193 4.67464 0 10.4184 0C16.1622 0 20.8368 4.67465 20.8368 10.4184C20.8368 19.3777 10.683 29.0461 10.5821 29.1416L10.4184 29.2971Z" fill="currentColor"/>
      <path d="M10.4184 16.9477C6.81832 16.9477 3.88916 14.0185 3.88916 10.4184C3.88916 6.81832 6.81832 3.88916 10.4184 3.88916C14.0185 3.88916 16.9477 6.81832 16.9477 10.4184C16.9477 14.0185 14.0185 16.9477 10.4184 16.9477Z" fill="white"/>
    </svg>`, 'image/svg+xml')
  return pin.documentElement;
}

let gmapKey, gmapLoader;

const useGmapLoader = async function () {
  if (gmapLoader) {
    return gmapLoader
  }

  if (!gmapKey) {
    gmapKey = await decryptStr(encryptedKey);
  }
  const gmapOptions = {}

  // Adagio requires client and channel to use maps.
  if (!useKey && client && channel) {
    gmapOptions.client = client
    gmapOptions.channel = channel
    // Keep API key as fallback for environments where client auth is unavailable.
    gmapOptions.key = gmapKey
  } else {
    // For Dev use Key.
    gmapOptions.key = gmapKey
  }

// Use quarterly map instead of static old version.
  gmapOptions.v = 'quarterly'

  gmapOptions.libraries = ['places', 'marker']

  gmapOptions.language = window?.drupalSettings?.google?.map?.LANGUAGE ?? 'en'

  setOptions(gmapOptions)
  await Promise.all([
    importLibrary('maps'),
    importLibrary('places'),
    importLibrary('marker'),
  ])
  gmapLoader = window.google
  return gmapLoader
}


export default useGmapLoader

export {
  mapIDs,
  getPinSVG,
}
